// Not-found feature – i18n manifest (veřejný kontrakt pro composition)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'not-found';

export const notFoundI18nManifest: SliceI18nManifest = {
  owner: 'features/not-found',
  namespaces: [NS],
  resources: {
    cs: {
      [NS]: cs,
    },
    en: {
      [NS]: en,
    },
  },
};
